import { useState } from "react";
import { ProfileModal } from "./ProfileModal";
import { cn } from "@/lib/utils";

export const ProviderNameOpenModal = ({
  userId,
  firstName,
  lastName,
  className,
}: {
  userId: string;
  firstName: string | null;
  lastName: string | null;
  className?: string;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleNameClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const fullName = [firstName, lastName].filter(Boolean).join(" ");

  return (
    <>
      <button
        onClick={handleNameClick}
        className={cn("text-left hover:underline", className)}
        aria-label={`View ${fullName}'s profile`}
        type="button"
      >
        {fullName}
      </button>
      {isModalOpen && (
        <ProfileModal userId={userId} onClose={handleCloseModal} />
      )}
    </>
  );
};
